import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './styles';

interface Props {
  error: string;
}

export const MultiInputError: React.FC<Props> = ({ error }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.root}>
      <Typography variant="caption" className={classes.typography}>
        {error}
      </Typography>
    </Grid>
  );
};
